import { createSelector } from '@ngrx/store';
import { IAppState } from '../app/app.state';
import { ISidebarState } from './sidebar.state';

const selectSidebarState = (state: IAppState) => state.sidebarState;

export const selectError = createSelector(
  selectSidebarState,
  (state: ISidebarState) => state.error
);

export const selectLoading = createSelector(
  selectSidebarState,
  (state: ISidebarState) => state.loading
);

export const selectSelectedPrimaryNavConfig = createSelector(
  selectSidebarState,
  (state: ISidebarState) => state.selectedPrimaryNavConfig
);

export const selectActivePrimaryNavMenuId = createSelector(
  selectSidebarState,
  (state: ISidebarState) => state.activePrimaryNavMenuId
);

export const selectActiveSecondaryNavMenuId = createSelector(
  selectSidebarState,
  (state: ISidebarState) => state.activeSecondaryNavMenuId
);

export const selectActiveTertiaryNavMenuId = createSelector(
  selectSidebarState,
  (state: ISidebarState) => state.activeTertiaryNavMenuId
);
